export enum ApplicationFilingStatusEnum {
    autoCoordSubmissionFailed = 'AutoCoord Submission Failed',
    coordinationFailed = 'Coordination - Failed',
    coordinationProcessing = 'Coordination - Processing',
    coordinationResultsReady = 'Coordination - Results Ready',
    coordinationSubmitted = 'Coordination - Submitted',
    ebfSubmissionFailed = 'EBF Submission Failed',
    ebfSubmitted = 'EBF Submitted',
    entryComplete = 'Entry Complete',
    entryCompleteSubmittedToEwa = 'Entry Complete - Submitted to EWA',
    entryIncomplete = 'Entry Incomplete',
    entryIncompleteSubmittedToEwa = 'Entry Incomplete - Submitted to EWA',
    failedTransmittalToFcc = 'Failed Transmittal to FCC',
    fccAwaitingResponse = 'FCC - Awaiting Response',
    fccReceived = 'FCC - Received (Ready for FCC Payment)',
    frequencyAvailabilityQueryComplete = 'Frequency Availability Query Complete',
    holdDay0 = '800 Hold - Day 0',
    holdDayX = '800 Hold - Day X',
    holdPost5DayHoldRevalidation = '800 - Post 5 Day Hold Revalidation',
    holdWaitOnPublicNoticeDate = '800 Hold - Wait on Public Notice Date',
    limitationCheckFailed = 'Limitation Check Failed',
    pendingTransmissionToFcc = 'Pending Transmision to FCC',
    rejectedByFcc = 'Rejected by FCC',
    submittedToEwa = 'Submitted to EWA',
    submittedToFcc = 'Submitted to FCC',
    submittedToEwaForCertification = 'Submitted to EWA for Certification',
    submittedToPsca = 'Submitted to PSCA',
}

/**
 * Pattern for 800 MHz hold filing statuses.
 * Note: This is a regex pattern because there are multiple filing statuses that start with "800 Hold" and we want to capture all of them without having to enumerate each one.
 */
export const ApplicationFilingStatus800MHzHoldPattern = /^800 Hold/;

/**
 * Pattern for 800 MHz hold filing statuses that include a day, e.g. "800 Hold - Day 1", "800 Hold - Day 2", etc.
 */
export const ApplicationFilingStatus800MHzHoldDayPattern = /^800 Hold - Day /;

/**
 * Pattern for PSCA filing statuses that include a day, e.g. "PSCA-I/S - Day 1", "PSCA-I/S - Day 2", etc.
 */
export const ApplicationFilingStatusPSCADayPattern = /^PSCA-I\/S - Day /;

export const CoordinationAllowedStatuses: ApplicationFilingStatusEnum[] = [
    ApplicationFilingStatusEnum.entryComplete,
    ApplicationFilingStatusEnum.entryCompleteSubmittedToEwa,
    ApplicationFilingStatusEnum.coordinationResultsReady,
    ApplicationFilingStatusEnum.coordinationFailed,
    ApplicationFilingStatusEnum.limitationCheckFailed,
    ApplicationFilingStatusEnum.rejectedByFcc,
    ApplicationFilingStatusEnum.failedTransmittalToFcc,
    ApplicationFilingStatusEnum.frequencyAvailabilityQueryComplete,
    ApplicationFilingStatusEnum.submittedToEwaForCertification,
    ApplicationFilingStatusEnum.ebfSubmissionFailed,
    ApplicationFilingStatusEnum.entryIncompleteSubmittedToEwa,
    ApplicationFilingStatusEnum.autoCoordSubmissionFailed,
];
